export default __webpack_public_path__ + "static/media/service-thumb-paver-fire-pit.14253395.jpg";